

















import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputFile extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly browseLabel!: string
    @Prop() readonly value!: File
    @Prop({ default: () => []}) readonly accept!: string[]
    internalValue: File = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    mounted() {
        this.validator.syncValue(this.internalValue)
        this.validator.validateSilent()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange() {
        const value = this.internalValue
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onChange(e: any): void {
        this.validator.validate(e)
        this.internalValue = e.target.files[0]
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get acceptedFileTypes(): string {
        if (this.accept.length === 0) {
            return null
        }

        return this.accept.join(',')
    }

    get componentClass(): object {
        return {
            'input-file': true,
            'input-file--focused': this.focus,
            'input-file--disabled': this.disabled,
        }
    }
}
